// src/components/PrivateRoute.js
import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

function PrivateRoute({ children }) {
  const { currentUser } = useAuth();

  if (!currentUser) {
    // Not logged in, redirect to sign-in
    return <Navigate to="/signin" />;
  }

  // Otherwise, render the children
  return children;
}

export default PrivateRoute;